import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-ee",
  "use": "icon-flag-ee-usage",
  "viewBox": "0 0 1541 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1541 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-ee\"><defs><style type=\"text/css\"></style></defs><path d=\"M6.29 1017.718h1519.038V6.282H6.29v1011.436z m1521.55 2.513v-3.77 3.77zM0.009 1024V0H1531.61v1022.744H0.008z\" fill=\"#353636\" p-id=\"5092\" /><path d=\"M3.777 680.991h1525.32v339.24H3.777z\" fill=\"#FFFFFF\" p-id=\"5093\" /><path d=\"M3.777 343.009h1525.32v339.239H3.777z\" fill=\"#231815\" p-id=\"5094\" /><path d=\"M3.777 3.77h1525.32v339.239H3.777z\" fill=\"#0087CD\" p-id=\"5095\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-ee.svg
// module id = zHIk
// module chunks = 24